import React from "react";
import { Link, useParams } from "react-router-dom";

import ItemDetailsContent from "./ItemDetailsContent";
import CommentsArea from "./CommentsArea";
import CommentForm from "./CommentForm";
import NewsletterBox from "./NewsletterBox";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
import RelatedBlog from "./RelatedBlog";

import blogs from "../../api/blogs";
import avatar1 from "../../images/avatar/avatar1.jpg";

const BlogDetailsSection: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  // Fallback to the first post when no slug is provided (e.g., /blog-details).
  const blog = slug
    ? blogs.find((b) => b.slug === slug)
    : blogs[0];

  if (!blog) {
    return (
      <section className="blog_details_section pt-70">
        <div className="container">
          <div className="text-center py-5">
            <h2 className="details-content-title mb-15">Post not found</h2>
            <p className="mb-35">
              The article you're looking for doesn't exist or may have been
              moved.
            </p>
            <Link className="thm-btn agency-btn" to="/blog">
              <span className="text">Back to blog</span>
            </Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="blog_details_section pt-70">
      <div className="container">
        {/* MAIN IMAGE */}
        <div className="single-item-image mb-70">
          <img src={blog.image} alt={blog.title} />
        </div>

        {/* HEADER META */}
        <ItemDetailsContent blog={blog} />

        {/* CONTENT ROW */}
        <div className="row mt-none-30 g-0 align-items-start">
          <div className="col-lg-8 mt-30">
            <div className="blog_details_content">
              {/* AUDIO BUTTON */}
              <div className="post_audio">
                <button className="audio_play_btn xb-border" type="button">
                  <i className="fas fa-play"></i>
                  <span className="time">{blog.readTime}</span>
                  <span>Listen to this article!</span>
                </button>
              </div>

              {/* POST CONTENT */}
              {blog.content}

              {/* AUTHOR BLOCK */}
              <div className="post-block-wrap mb-50 mt-50">
                <div className="postabmin_block xb-border ul_li">
                  <div className="admin_image">
                    <img src={avatar1} alt={blog.author} />
                  </div>

                  <div className="admin_content">
                    <h4 className="admin_name">{blog.author}</h4>
                    <span className="admin_designation">{blog.authorRole}</span>
                    <p>
                      {blog.author} writes about SMM panels, growth tactics,
                      and the business side of social media marketing for
                      creators and resellers.
                    </p>

                    <ul className="social_icons_blocks list-unstyled ul_li">
                      <li>
                        <Link to={`/blog/${blog.slug}`}>
                          <i className="fab fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to={`/blog/${blog.slug}`}>
                          <i className="fab fa-instagram"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to={`/blog/${blog.slug}`}>
                          <i className="fab fa-linkedin-in"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* TAGS + SOCIAL */}
              <div className="row mt-none-30">
                <div className="col-md-6 mt-30">
                  <ul className="tags_block list-unstyled">
                    <li>
                      <Link className="xb-border" to={`/blog/${blog.slug}`}>
                        {blog.tag}
                      </Link>
                    </li>
                    <li>
                      <Link className="xb-border" to={`/blog/${blog.slug}`}>
                        {blog.category}
                      </Link>
                    </li>
                    <li>
                      <Link className="xb-border" to="/blog">
                        All posts
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="social_icons_block list-unstyled ul_li justify-content-md-end">
                    <li>
                      <Link className="xb-border" to={`/blog/${blog.slug}`}>
                        <i className="fab fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link className="xb-border" to={`/blog/${blog.slug}`}>
                        <i className="fab fa-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link className="xb-border" to={`/blog/${blog.slug}`}>
                        <i className="fab fa-linkedin-in"></i>
                      </Link>
                    </li>
                    <li>
                      <Link className="xb-border" to={`/blog/${blog.slug}`}>
                        <i className="fab fa-instagram"></i>
                      </Link>
                    </li>
                    <li>
                      <Link className="xb-border" to={`/blog/${blog.slug}`}>
                        <i className="fas fa-share-alt"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* COMMENTS AREA */}
              <CommentsArea />

              {/* COMMENT FORM */}
              <CommentForm />

              {/* SUBSCRIBE BOX */}
              <NewsletterBox />
            </div>
          </div>
          <BlogSidebar />
        </div>

        <RelatedBlog currentSlug={blog.slug} />
      </div>
    </section>
  );
};

export default BlogDetailsSection;
